<template>
  <!-- Progress Bar -->
  <div class="progress-bar p-3 bg-gray-900 border-b border-t border-gray-800">
    <div class="flex justify-between mb-2 text-sm">
      <span :class="{ 'text-white': currentStep >= 0, 'text-gray-400': currentStep < 0 }">0. ยอมรับเงื่อนไข</span>
      <span :class="{ 'text-white': currentStep >= 1, 'text-gray-400': currentStep < 1 }">1. เลือกเลือกภาพ</span>
      <span :class="{ 'text-white': currentStep >= 2, 'text-gray-400': currentStep < 2 }">2. เลือกลักษณะนิสัย</span>
      <span :class="{ 'text-white': currentStep >= 3, 'text-gray-400': currentStep < 3 }">3. ตั้งชื่อ</span>
      <span :class="{ 'text-white': currentStep >= 4, 'text-gray-400': currentStep < 4 }">4. เลือกตึก</span>
    </div>
    <div class="w-full bg-gray-700 rounded-full h-2">
      <div
        class="bg-indigo-500 h-2 rounded-full transition-all duration-200"
        :style="{ width: `${(currentStep / 5) * 100}%` }"
      ></div>
    </div>
  </div>
  <div class="p-3 pb-20 bg mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 text-white" id="style-1">
    <!-- Step 0: Terms and Conditions -->
    <transition name="fade">
      <div v-if="currentStep === 0" class="step-content max-w-7xl mx-auto">
        <h2 class="text-lg sm:text-xl font-semibold mb-4">เงื่อนไขการใช้งานและการเล่น</h2>
        <div class="bg-gray-800 p-4 rounded-lg border border-gray-700 max-h-96 overflow-auto">
          <h3 class="text-base font-semibold mb-2">เงื่อนไขการใช้งานเว็บไซต์</h3>
          <p class="text-sm text-gray-300 mb-4">
            1. ผู้เล่นต้องปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้องในประเทศไทย<br>
            2. ห้ามใช้เว็บไซต์เพื่อวัตถุประสงค์ที่ผิดกฎหมายหรือไม่เหมาะสม<br>
            3. ผู้เล่นต้องไม่พยายามเจาะระบบหรือแก้ไขข้อมูลของเว็บไซต์<br>
            4. ข้อมูลส่วนบุคคลของผู้เล่นจะได้รับการปกป้องตามนโยบายความเป็นส่วนตัว<br>
            5. ผู้พัฒนาเกมขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
          </p>
          <h3 class="text-base font-semibold mb-2">เงื่อนไขการเล่นเกม</h3>
          <p class="text-sm text-gray-300 mb-4">
            1. ผู้เล่นต้องสร้างตัวละครโดยใช้ชื่อที่เหมาะสมและไม่ขัดต่อศีลธรรม<br>
            2. ห้ามใช้บั๊กหรือช่องโหว่ของเกมเพื่อผลประโยชน์ส่วนตัว<br>
            3. ผู้เล่นต้องปฏิบัติตามกฎของชุมชนในเกม เช่น ไม่รบกวนผู้เล่นอื่น<br>
            4. การเติมเงินในเกมไม่สามารถขอคืนเงินได้ไม่ว่ากรณีใด ๆ<br>
            5. ผู้พัฒนาไม่รับผิดชอบต่อการแลกเปลี่ยนไอเทมหรือทรัพย์สินใด ๆ ระหว่างผู้เล่น<br>
            6. หนึ่งที่อยู่ IP สามารถใช้เล่นเกมได้เพียงอุปกรณ์เดียวเท่านั้น<br>
            7. เมื่อตัวละครของผู้เล่นเสียชีวิต — ไม่ว่าจะเกิดจากการ PvP, ความหิว, ความสุขต่ำ หรือสาเหตุอื่นใด ตัวละครจะสูญเสียไอเทม ลายสัก ทักษะ และทรัพย์สินอื่น ๆ ที่ถือครองอยู่ในขณะนั้น โดยไม่สามารถเรียกร้องคืนได้ไม่ว่ากรณีใด
            8. ผู้พัฒนาขอสงวนสิทธิ์ในการระงับบัญชีหากพบการกระทำที่ขัดต่อเงื่อนไข
          </p>
        </div>
        <div class="flex items-center mt-4">
          <input
            v-model="termsAccepted"
            type="checkbox"
            id="terms-checkbox"
            class="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-600 rounded"
          />
          <label for="terms-checkbox" class="ml-2 text-sm text-gray-300">
            ฉันยอมรับเงื่อนไขการใช้งานและการเล่นทั้งหมด
          </label>
        </div>
        <p v-if="termsError" class="text-red-300 text-sm mt-2">{{ termsError }}</p>
      </div>
    </transition>

    <!-- Step 1: เลือกภาพตัวละคร -->
    <transition name="fade">
      <div v-if="currentStep === 1" class="step-content max-w-7xl mx-auto">
        <h2 class="text-lg sm:text-xl font-semibold mb-4">เลือกภาพตัวละคร</h2>
        <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
          <img
            v-for="(image, index) in availableImages"
            :key="index"
            :src="image"
            @click="selectImage(image)"
            :class="[
              'w-full h-full object-cover rounded-lg cursor-pointer transition-all duration-200',
              selectedImage === image ? 'border-4 border-indigo-500' : 'border-2 border-gray-700 hover:shadow-lg'
            ]"
          />
        </div>
      </div>
    </transition>

    <!-- Step 2: เลือกลักษณะนิสัย -->
    <transition name="fade">
      <div v-if="currentStep === 2" class="step-content max-w-7xl mx-auto">
        <h2 class="text-lg sm:text-xl font-semibold mb-4">เลือกลักษณะนิสัย</h2>
        <div class="space-y-4">
          <div
            v-for="trait in availableTraits"
            :key="trait.id"
            @click="selectTrait(trait)"
            :class="[
              'p-3 rounded-lg cursor-pointer transition-all duration-200 bg-gray-800 border',
              selectedTrait && selectedTrait.id === trait.id ? 'border-indigo-500' : 'border-gray-700 hover:bg-gray-700'
            ]"
          >
            <div class="flex items-center justify-between">
              <div>
                <span class="text-base font-semibold text-white">{{ trait.name }}</span>
                <p class="text-sm text-gray-400">{{ trait.background }}</p>
              </div>
              <div class="flex space-x-2 text-sm text-gray-400">
                <span><i class="fas fa-fist-raised mr-1"></i>{{ trait.stats.str }}</span>
                <span><i class="fas fa-heart mr-1"></i>{{ trait.stats.stamina }}</span>
                <span><i class="fas fa-brain mr-1"></i>{{ trait.stats.int }}</span>
                <span><i class="fas fa-running mr-1"></i>{{ trait.stats.agi }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Step 3: ตั้งชื่อตัวละคร -->
    <transition name="fade">
      <div v-if="currentStep === 3" class="step-content max-w-7xl mx-auto flex flex-col items-center">
        <h2 class="text-lg sm:text-xl font-semibold mb-4">ตั้งชื่อตัวละคร</h2>
        <img
          :src="selectedImage"
          class="w-24 h-24 object-cover rounded-full mb-4 border-2 border-indigo-500"
        />
        <p class="text-sm text-gray-400 mb-4">ลักษณะนิสัย: {{ selectedTrait.name }}</p>
        <input
          v-model="characterNameInput"
          type="text"
          placeholder="ชื่อ (ภาษาไทย ไม่เกิน 10 ตัวอักษร)"
          maxlength="10"
          class="w-full max-w-sm p-2 rounded-lg bg-gray-700 border border-gray-600 text-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200"
          @input="validateCharacterName"
        />
        <p v-if="nameValidationError" class="text-red-300 text-sm mt-2">{{ nameValidationError }}</p>
      </div>
    </transition>

    <!-- Step 4: เลือกตึก -->
    <transition name="fade">
      <div v-if="currentStep === 4" class="step-content max-w-7xl mx-auto">
        <h2 class="text-lg sm:text-xl font-semibold mb-4">เลือกตึกที่ต้องการเข้าร่วม</h2>
        <div class="space-y-4">
          <div
            @click="selectBuilding(1)"
            :class="[
              'p-4 rounded-lg cursor-pointer transition-all duration-200 bg-gray-800 border',
              selectedBuilding === 1 ? 'border-indigo-500' : 'border-gray-700 hover:bg-gray-700'
            ]"
          >
            <h3 class="text-base font-semibold text-white">ตึกที่ 1: ระบบปิดชื่อ (แนะนำสำหรับมือใหม่)</h3>
            <p class="text-sm text-gray-400">
              - เหมาะสำหรับผู้เล่นสายโซโล่ที่ต้องการความเป็นส่วนตัว<br>
              - ปิดชื่อชื่อ ในโหมดลอบสังหาร<br>
            </p>
          </div>
          <div
            :class="[
              'p-4 rounded-lg transition-all duration-200 bg-gray-800 border border-gray-700 opacity-50 cursor-not-allowed'
            ]"
          >
            <h3 class="text-base font-semibold text-gray-400">ตึกที่ 2: ระบบปิดชื่อ (ปิดให้บริการชั่วคราว)</h3>
            <p class="text-sm text-gray-400">
              - ปิดให้บริการชั่วคราวสำหรับตัวละครใหม่<br>
            </p>
          </div>
        </div>
      </div>
    </transition>

    <!-- Error Message -->
    <div v-if="errorMessage" class="text-red-300 text-center mt-4 text-sm">
      {{ errorMessage }}
    </div>

    <!-- Navigation Buttons -->
    <div class="flex justify-between mt-6 max-w-7xl mx-auto">
      <button
        v-if="currentStep > 0"
        @click="currentStep--"
        class="py-2 px-4 rounded-lg bg-gray-600 hover:bg-gray-500 border border-gray-600 text-sm font-semibold transition-all duration-200"
      >
        <i class="fas fa-arrow-left mr-1"></i>ย้อนกลับ
      </button>
      <button
        v-if="currentStep < 4"
        @click="nextStep"
        :disabled="!canProceed"
        :class="[
          'py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ml-auto',
          canProceed
            ? 'bg-indigo-600 hover:bg-indigo-500 border border-indigo-700'
            : 'bg-gray-600 opacity-0.6 cursor-not-allowed border border-gray-600'
        ]"
      >
        ถัดไป<i class="fas fa-arrow-right ml-1"></i>
      </button>
      <button
        v-if="currentStep === 4"
        @click="submitCharacterCreation"
        :disabled="!isFormComplete || isSubmitting"
        :class="[
          'py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ml-auto',
          isFormComplete && !isSubmitting
            ? 'bg-indigo-600 hover:bg-indigo-500 border border-indigo-700'
            : 'bg-gray-600 opacity-0.6 cursor-not-allowed border border-gray-600'
        ]"
      >
        <span v-if="!isSubmitting"><i class="fas fa-check mr-1"></i>สร้างตัวละคร</span>
        <i v-else class="fas fa-spinner animate-spin text-indigo-200"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { projectFunctions } from '@/firebase/config';
import { useRouter } from 'vue-router';

export default {
  name: 'CreateCharacterWizard',
  setup() {
    const router = useRouter();

    const availableImages = [
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F1.png?alt=media&token=ab292e26-7fa9-4e41-9ca7-8516c730845f',
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F2.png?alt=media&token=c007f433-6ab4-4c02-acdf-e7b987246d4b',
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F3.png?alt=media&token=c8460a3c-8c11-4a4c-928b-ccfa09a385be',
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F4.png?alt=media&token=812dbf65-cbde-44c0-bbed-600aadc2d22a',
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F5.png?alt=media&token=bd310014-b622-4fdf-80dd-1ebdead07a41',
      'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/character2%2F6.png?alt=media&token=ec9cc5de-50c1-4c7f-b15e-220d1f3e226f',
    ];

    const availableTraits = ref([
      {
        id: 1,
        name: 'ว่องไว',
        background: 'เคลื่อนไหวรวดเร็ว หนีซอมบี้ได้ไว',
        stats: { str: 3, stamina: 10, int: 0, agi: 5 },
      },
      {
        id: 2,
        name: 'กล้าหาญ',
        background: 'กล้าเผชิญหน้า ต่อสู้เก่ง',
        stats: { str: 6, stamina: 10, int: 0, agi: 0 },
      },
      {
        id: 3,
        name: 'ฉลาด',
        background: 'ชาญฉลาด สร้างกับดักเก่ง',
        stats: { str: 3, stamina: 10, int: 5, agi: 0 },
      },
      {
        id: 4,
        name: 'อดทน',
        background: 'เยือกเย็น อึด',
        stats: { str: 3, stamina: 15, int: 0, agi: 0 },
      },
    ]);

    // ตัวแปรสถานะ
    const currentStep = ref(0);
    const termsAccepted = ref(false);
    const termsError = ref('');
    const selectedImage = ref(null);
    const selectedTrait = ref(null);
    const characterNameInput = ref('');
    const nameValidationError = ref('');
    const selectedBuilding = ref(null);
    const isSubmitting = ref(false);
    const errorMessage = ref('');

    // ฟังก์ชันเลือกภาพ
    const selectImage = (image) => {
      selectedImage.value = image;
      errorMessage.value = '';
    };

    // ฟังก์ชันเลือกลักษณะนิสัย
    const selectTrait = (trait) => {
      selectedTrait.value = trait;
      errorMessage.value = '';
    };

    // ฟังก์ชันเลือกตึก
    const selectBuilding = (building) => {
      if (building === 1) {
        selectedBuilding.value = building;
        errorMessage.value = '';
      }
    };

    // ฟังก์ชันตรวจสอบชื่อ
    const validateCharacterName = () => {
      const thaiValidWordRegex = /^(?![\u0E01-\u0E2E\s]+$)([\u0E00-\u0E7F\s])+$/;
      const input = characterNameInput.value.trim();

      if (!input) {
        nameValidationError.value = 'กรุณากรอกชื่อตัวละคร';
      } else if (!thaiValidWordRegex.test(input)) {
        nameValidationError.value = 'ชื่อต้องเป็นคำที่ถูกต้องในภาษาไทย';
      } else if (input.length > 10) {
        nameValidationError.value = 'ชื่อต้องไม่เกิน 10 ตัวอักษร';
      } else {
        nameValidationError.value = '';
      }
      errorMessage.value = '';
    };

    // ตรวจสอบว่าสามารถไปขั้นตอนถัดไปได้หรือไม่
    const canProceed = computed(() => {
      if (currentStep.value === 0) return termsAccepted.value;
      if (currentStep.value === 1) return !!selectedImage.value;
      if (currentStep.value === 2) return !!selectedTrait.value;
      if (currentStep.value === 3) return !!characterNameInput.value && !nameValidationError.value;
      if (currentStep.value === 4) return selectedBuilding.value !== null;
      return false;
    });

    // ตรวจสอบว่าฟอร์มครบถ้วนหรือไม่
    const isFormComplete = computed(() => {
      return termsAccepted.value && selectedImage.value && selectedTrait.value && characterNameInput.value && !nameValidationError.value && selectedBuilding.value !== null;
    });

    // ไปขั้นตอนถัดไป
    const nextStep = () => {
      if (currentStep.value === 0 && !termsAccepted.value) {
        termsError.value = 'กรุณายอมรับเงื่อนไขก่อนดำเนินการต่อ';
        return;
      }
      if (canProceed.value && currentStep.value < 4) {
        termsError.value = '';
        currentStep.value++;
      }
    };

    // ส่งข้อมูลไปยัง server และ redirect
    const submitCharacterCreation = async () => {
      if (!isFormComplete.value) return;

      const characterData = {
        action: 'characterActions',
        subAction: 'createCharacter',
        imgSelected: selectedImage.value,
        traitId: selectedTrait.value.id,
        name: characterNameInput.value,
        building: selectedBuilding.value,
      };

      isSubmitting.value = true;
      errorMessage.value = '';
      try {
        const characterActionsFunction = projectFunctions.httpsCallable('gameActions');
        const result = await characterActionsFunction(characterData);
        console.log('Server response:', result.data);
        await router.push({ name: 'Home' });
        window.location.reload();
      } catch (error) {
        console.error('Error creating character:', error);
        errorMessage.value = error.message || 'เกิดข้อผิดพลาดในการสร้างตัวละคร';
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      currentStep,
      termsAccepted,
      termsError,
      availableImages,
      availableTraits,
      selectedImage,
      selectedTrait,
      characterNameInput,
      nameValidationError,
      selectedBuilding,
      isSubmitting,
      errorMessage,
      selectImage,
      selectTrait,
      selectBuilding,
      validateCharacterName,
      nextStep,
      submitCharacterCreation,
      canProceed,
      isFormComplete,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#style-1::-webkit-scrollbar {
  width: 5px;
}
#style-1::-webkit-scrollbar-track {
  background: #374151;
  border-radius: 10px;
}
#style-1::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 10px;
}
#style-1::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
#style-1 {
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #374151;
}
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fcondo.png?alt=media&token=198ebb1c-66e5-4bf0-aa79-32bff287aa09') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
  background-size: cover;
}
</style>